import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {storeUser} from "@/stores/user";
import {storeToRefs} from "pinia";
import LayoutIN from "@/layouts/LayoutIN.vue";
import LayoutOUT from "@/layouts/LayoutOUT.vue";
import InfoTags from '@/components/InfoTags.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const _userStore = storeUser();
const {isLogged} = storeToRefs(_userStore);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isLogged))
      ? (_openBlock(), _createBlock(LayoutOUT, { key: 0 }))
      : (_openBlock(), _createBlock(LayoutIN, { key: 1 })),
    _createVNode(InfoTags)
  ], 64))
}
}

})